import { dataProps } from './properties'

export const setTenantList = (state, payload) => {
    state.list = payload
}    

export const setTenantData = (state, payload) => {
    state.props = payload
} 

export const resetTenantData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/tenants/mutations.js